/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Product Selects subscribers table fields config
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.10.0
 */

import { ITableReducer } from '../../../../components/Table/reducers/tableReducer';
import { TableNameType } from '../../../../components/Table/types/tableTypes';
import { IWizardProductOfferingsTranslation } from '../../../../modules/internationalization/types';
import { EProductSubscribersTableField } from '../../wizardProductOfferingsConstants';

export const getProductSelectSubscribersTableFields = (
    isTariff: boolean,
    isDisconnect: boolean,
    translation: IWizardProductOfferingsTranslation,
): ITableReducer[TableNameType]['fields'] => {
    const fields = [
        {
            name: EProductSubscribersTableField.MSISDN,
            label: translation.table[EProductSubscribersTableField.MSISDN].header,
            checked: true,
            order: 0,
            resizable: true,
            size: 170,
            type: 'C',
        },
        {
            name: EProductSubscribersTableField.ACCOUNT,
            label: translation.table[EProductSubscribersTableField.ACCOUNT].header,
            checked: true,
            order: 1,
            resizable: true,
            size: 170,
            type: 'S',
        },
        {
            name: EProductSubscribersTableField.NAME,
            label: translation.table[EProductSubscribersTableField.NAME].header,
            checked: true,
            order: 2,
            resizable: true,
            size: 280,
            type: 'S',
        },
        {
            name: EProductSubscribersTableField.LABELS,
            label: translation.table[EProductSubscribersTableField.LABELS].header,
            checked: true,
            order: 3,
            resizable: true,
            size: 210,
            type: 'S',
        },
    ];
    /**
     * Тариф
     */
    isTariff && fields.push({
        name: EProductSubscribersTableField.RATE_PLAN,
        label: translation.table[EProductSubscribersTableField.RATE_PLAN].header,
        checked: true,
        order: 4,
        resizable: true,
        size: 200,
        type: 'S',
    });
    /**
     * Доступность
     */
    fields.push({
        name: EProductSubscribersTableField.ACTION_CONFLICTS,
        label: translation.table[EProductSubscribersTableField.ACTION_CONFLICTS].header,
        checked: true,
        order: 5,
        resizable: true,
        size: 200,
        type: 'S',
    });
    /**
     * Стоимость
     */
    !isDisconnect && fields.push({
        name: EProductSubscribersTableField.COST,
        // @ts-ignore
        description: translation.table[EProductSubscribersTableField.COST].description,
        label: translation.table[EProductSubscribersTableField.COST].header,
        checked: true,
        order: 6,
        resizable: true,
        size: 120,
        type: 'S',
    });
    // @ts-ignore
    return fields;
}
